export default "__VITE_ASSET__D50S$VjG__"